import React, {Component} from 'react';
import ReactNotification from 'react-notifications-component';

import Cabecera from './Cabecera';
import Pie from './Pie';
import ShoppingCart from './ShoppingCart';

import 'react-notifications-component/dist/theme.css';

class LayoutMain extends Component {

  constructor(props) {
    super(props);
    this.state = {
      main: true,
    };
  }
  setStateGlobal = (state) => {
    window.location.reload(false);
  }

  render() {
    return (
      <div className='expandFullPage'>
        <ReactNotification />
        <ShoppingCart />
        <div className='body'>
          <Cabecera parentState={this.state} setParentStateSteps={this.setStateGlobal} showAdminLogin={true}/> {this.props.children}
        </div>
        <Pie tieneFlecha = "true" />
      </div>
    );
  }
}

export default LayoutMain;
